// Review setting
export const GET_SURVEY_REVIEW = "GET_SURVEY_REVIEW";
export const CREATE_SURVEY_REVIEW = "CREATE_SURVEY_REVIEW";
export const DELETE_SURVEY_REVIEW = "DELETE_SURVEY_REVIEW";
export const UPDATE_SURVEY_REVIEW = "UPDATE_SURVEY_REVIEW";
export const ACTIVE_SURVEY_REVIEW = "ACTIVE_SURVEY_REVIEW";
export const INACTIVE_SURVEY_REVIEW = "INACTIVE_SURVEY_REVIEW";
export const GET_STAFF_RATING_ANSWER = "GET_STAFF_RATING_ANSWER";
export const CREATE_ANSWER = "CREATE_ANSWER";
export const UPDATE_ANSWER = "UPDATE_ANSWER";
export const CHANGE_ANSWER_STATUS = "CHANGE_ANSWER_STATUS";

export const GET_DEVICE_LIST = "GET_DEVICE_LIST";
export const DELETE_DEVICE = "DELETE_DEVICE";
export const UPDATE_STAFF_RATING_DEVICE = "UPDATE_STAFF_RATING_DEVICE";


export const GET_GOOGLE_REVIEW = "GET_GOOGLE_REVIEW";
export const CREATE_GOOGLE_REVIEW = "CREATE_GOOGLE_REVIEW";
export const DELETE_GOOGLE_REVIEW = "DELETE_GOOGLE_REVIEW";
export const UPDATE_GOOGLE_REVIEW = "UPDATE_GOOGLE_REVIEW";
export const ACTIVE_GOOGLE_REVIEW = "ACTIVE_GOOGLE_REVIEW";
export const INACTIVE_GOOGLE_REVIEW = "INACTIVE_GOOGLE_REVIEW";

// Review list
export const GET_REVIEW_LIST = "GET_REVIEW_LIST";
export const GET_REVIEW_REPORT = "GET_REVIEW_REPORT";

// Review list new
export const GET_ALL_REVIEW_LIST = 'GET_ALL_REVIEW_LIST';
export const GET_GOCHECKIN_REVIEW_LIST = 'GET_GOCHECKIN_REVIEW_LIST';
export const GET_YELP_REVIEW_LIST = 'GET_YELP_REVIEW_LIST';
export const GET_GOOGLE_REVIEW_LIST = 'GET_GOOGLE_REVIEW_LIST';
export const SORT_ALL_REVIEW = 'SORT_ALL_REVIEW';
export const SEARCH_BY_NAME = 'SEARCH_BY_NAME';
export const GET_SYSTEM_MESSAGE = 'GET_SYSTEM_MESSAGE';
export const REPLY_GOCHECKIN_REVIEW = 'REPLY_GOCHECKIN_REVIEW';
export const REPLY_GOOGLE_REVIEW = 'REPLY_GOOGLE_REVIEW';
export const UPDATE_GOOGLE_REPLY_REVIEW = 'UPDATE_GOOGLE_REPLY_REVIEW';
export const DELETE_GOOGLE_REPLY_REVIEW = 'DELETE_GOOGLE_REPLY_REVIEW';
export const CHECK_REVIEW_REPLY_PERMISSION = "CHECK_REVIEW_REPLY_PERMISSION";

//Staff rating
export const GET_STAFF_RATING_LIST = "GET_STAFF_RATING_LIST"
